import React from 'react';

/**
 * AdCard component props
 *
 * @interface AdCardProps
 */
export interface AdCardProps {
  /** @member {string} `image` Source of the background image */
  image: string;
  /** @member {string} `title` Title text */
  title: string;
  /** @member {string} `text` Main content */
  text: string;
  /** @member {string} `href` Redirect URLs */
  href: string;
  /** @member {string} `text` Call to action text  */
  ctaText: string;
  /** @member {string} `imageAlt` Alt tag for the image */
  imageAlt: string;
  /** @member {string} `textColour` Text colour in RGB format like `A1A1A1` */
  textColour: string;
  /** @member {string} `textBackgroundColour` Text background colour in RGB format like `A1A1A1` */
  textBackgroundColour: string;
  /** @member {number} `textBackgroundOpacity` Text background opacity. Range 0-1 */
  textBackgroundOpacity: number;
  /** @member {string | undefined} `className` CSS classname */
  className?: string;
}

const AdCard = ({ image, title, text, ctaText, href, imageAlt, textColour, textBackgroundColour, textBackgroundOpacity, className = '' }: AdCardProps) => {
  return (
    <div className={`ad-card__wrapper ${className}`}>
      <a
        className="ad-card ad-card--show"
        href={href}
        data-lpos="ad card"
      >
        <div className="ad-card__overlay" style={{ opacity: textBackgroundOpacity }}></div>
        <img className="ad-card__self" src={image} alt={imageAlt} />
        <div className="ad-card__content">
          <span className="ad-card__content-title" style={{ color: `#${textColour}`, backgroundColor: `#${textBackgroundColour}`}}>{title}</span>
          <span className="ad-card__content-text" style={{ color: `#${textColour}`, backgroundColor: `#${textBackgroundColour}`}}>{text}</span>
          <span className="ad-card__content-cta__title" style={{ color: `#${textColour}`, backgroundColor: `#${textBackgroundColour}`}}>{ctaText}</span>
        </div>
      </a>
    </div>
  );
};

export default AdCard;
